/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_AntarcticaInputs */

const bn_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যান্টার্কটিকা`)
};

const de_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarktis`)
};

const el_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανταρκτική`)
};

const en_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarctica`)
};

const es_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antártida`)
};

const fr_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarctique`)
};

const hi_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंटार्कटिका`)
};

const hu_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarktisz`)
};

const id_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antartika`)
};

const it_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antartide`)
};

const ja_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南極大陸`)
};

const ko_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남극 대륙`)
};

const nl_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarctica`)
};

const pl_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarktyda`)
};

const pt_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antártica`)
};

const ru_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Антарктида`)
};

const sv_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarktis`)
};

const tr_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antarktika`)
};

const uk_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Антарктида`)
};

const vi_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nam Cực`)
};

const zh_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南极洲`)
};

const zh_hant_geo_label_antarctica = /** @type {(inputs: Geo_Label_AntarcticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南極洲`)
};

/**
* | output |
* | --- |
* | "Antarctica" |
*
* @param {Geo_Label_AntarcticaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_antarctica = /** @type {((inputs?: Geo_Label_AntarcticaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_AntarcticaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_antarctica(inputs)
	if (locale === "de") return de_geo_label_antarctica(inputs)
	if (locale === "el") return el_geo_label_antarctica(inputs)
	if (locale === "en") return en_geo_label_antarctica(inputs)
	if (locale === "es") return es_geo_label_antarctica(inputs)
	if (locale === "fr") return fr_geo_label_antarctica(inputs)
	if (locale === "hi") return hi_geo_label_antarctica(inputs)
	if (locale === "hu") return hu_geo_label_antarctica(inputs)
	if (locale === "id") return id_geo_label_antarctica(inputs)
	if (locale === "it") return it_geo_label_antarctica(inputs)
	if (locale === "ja") return ja_geo_label_antarctica(inputs)
	if (locale === "ko") return ko_geo_label_antarctica(inputs)
	if (locale === "nl") return nl_geo_label_antarctica(inputs)
	if (locale === "pl") return pl_geo_label_antarctica(inputs)
	if (locale === "pt") return pt_geo_label_antarctica(inputs)
	if (locale === "ru") return ru_geo_label_antarctica(inputs)
	if (locale === "sv") return sv_geo_label_antarctica(inputs)
	if (locale === "tr") return tr_geo_label_antarctica(inputs)
	if (locale === "uk") return uk_geo_label_antarctica(inputs)
	if (locale === "vi") return vi_geo_label_antarctica(inputs)
	if (locale === "zh") return zh_geo_label_antarctica(inputs)
	return zh_hant_geo_label_antarctica(inputs)
});